module.exports = __webpack_public_path__ + "img/7b88329.jpg";